<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <button class="btn-close" @click="closeModal()"></button>
            <div class="modal-container">
                <div class="modal-body">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        closeModal: function () {
            this.emitter.emit('close-modal')
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/variables';

.modal-mask {
    background-color: var(--white);
    display: table;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    transition: opacity 0.3s ease;
    width: 100%;
    z-index: 9998;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    position: relative;

    .close-button {
        background-color: transparent;
        border: none;
        position: absolute;
        right: 16px;
        top: 16px;
    }
}

.modal-container {
    border-radius: 2px;
    font-family: Helvetica, Arial, sans-serif;
    margin: 0px auto;
    max-width: 650px;
    padding: 0 20px;

    transition: all 0.3s ease;
    width: 100%;
}

.modal-body {
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    margin: 20px 0;
}

.modal-default-button {
    float: right;
}
</style>
